import dayjs from 'dayjs';
import { cloneDeep, isNil } from 'lodash-es';

declare const AnalysysAgent: any;

const SCENE_DATA_KEY = '_scene_data';
export const covertField = (
  target: any,
  fields = [
    'enter_time',
    'leave_time',
    'start_time',
    'execute_time',
    'task_id',
    'task_name',
    'value_chain_name',
    'value_chain_id',
    'scene_name',
    'scene_id',
  ],
) => {
  const res = cloneDeep(target);
  for (const snakeKey of fields) {
    // 下划线格式转驼峰格式
    const camelKey = snakeKey.split('_').reduce((result, str, i) => {
      let _str = str.split('');
      if (i > 0) {
        _str[0] = _str[0].toUpperCase();
      }
      result += _str.join('');
      return result;
    }, '');
    // console.log(target, camelKey);
    if (!isNil(target[camelKey]) && target[camelKey] !== '') {
      res[snakeKey] = target[camelKey];
    }
    delete res[camelKey];
  }
  return res;
};

export const track = (eventName: string, eventInfo: any) => {
  let _info = covertField(eventInfo);
  if (['task_page_view', 'task_page_close', 'task_execute'].includes(eventName)) {
    _info['path'] = location.href;
  }

  if (eventName === 'task_execute') {
    _info.duration = _info.duration || dayjs(_info['execute_time']).diff(_info['start_time'], 'seconds');
  }
  // console.log(eventName, _info);
  if (AnalysysAgent) {
    const workNumber = AnalysysAgent.getSuperProperty('work_number');
    if (!isNil(workNumber)) {
      AnalysysAgent.track(eventName, _info);
    } else {
      console.error('workNumber is Nil');
    }
  }
};

export const pageView = (pageName: any, properties: any, callback: any) => {
  AnalysysAgent && AnalysysAgent.pageView(pageName, properties, callback);
};

export const parseSceneData = () => {
  let sceneData = {};
  const params = location.href.split('?')[1];
  // console.log('params', params);
  if (params) {
    const arr = params.split('&');
    for (const item of arr) {
      const [key, value] = item.split('=');
      if (['value_chain_id', 'value_chain_name', 'scene_id', 'scene_name', 'task_id', 'task_name'].includes(key)) {
        sceneData[key] = decodeURIComponent(value);
      }
    }
  }
  return sceneData;
};
export const saveSceneData = (sceneData: any) => {
  sessionStorage.setItem(SCENE_DATA_KEY, JSON.stringify(sceneData));
};

export const getSceneData = () => {
  let res: any = sessionStorage.getItem(SCENE_DATA_KEY) || '';
  if (res && res !== '{}') {
    try {
      res = JSON.parse(res);
    } catch (err) {
      console.log('err', err);
    }
  }
  // console.log('getSceneData', res);
  return res;
};
export default track;
